import { getChEditExistingBillingData } from "@/modules/common/billing/components/billing-form/ch/edit/libs/getChEditExistingBillingData"
import { DEFAULT_NOT_BILLABLE_REASON } from "@/modules/common/billing/components/billing-form/constants"
import { Law, NotBillableReason, Service, TreatmentReason } from "@/types/__generated__/union-types"

type Appointment = {
  service: Service
}

type BillingAttribute = {
  readonly treatmentReason: TreatmentReason | null
  readonly accidentReference: string | null
  readonly dateOfAccident: string | null
  readonly id: string
  readonly isEmployer: boolean | null
  readonly isNotBillable: boolean
  readonly notBillableReason: NotBillableReason | null
  readonly organisationId: string | null
  readonly reason: string | null
  readonly lawType: Law | null
  readonly ivgCaseReference: string | null
  readonly mvgCaseReference: string | null
}

export const getChEditBillingDefaultValues = (appointment: Appointment, billingAttribute: BillingAttribute | null) => {
  const isAdministrativeRequest = appointment.service === "ADMINISTRATIVE_REQUEST"
  const existingBillingData = getChEditExistingBillingData(billingAttribute)

  if (existingBillingData) {
    return isAdministrativeRequest ? { ...existingBillingData, isNotBillable: false } : existingBillingData
  }

  return {
    isNotBillable: false,
    notBillableReason: DEFAULT_NOT_BILLABLE_REASON,
    reason: "",
  }
}
